import { APPIDS } from '@/constants/appid.config.js';
/**
 * @typedef {object} AppConfig
 * @property {string} appid - The application ID.
 * @property {string | null} type - The application type.
 */
export function baseInfoConfig() {
  /**
   * @returns {AppConfig | undefined} 
   */
  function getAppidConfig() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 0) {
      const key = parts[0];

      if (Object.prototype.hasOwnProperty.call(APPIDS, key)) {
        return APPIDS[key];
      }
    }
    console.warn('No matching app configuration found for hostname:', hostname);
    return undefined;
  }

  return {
    getAppidConfig
  };
}

